import { bgTypes } from 'styles/generateBgStyleByType';

export const COVER_TABS = {
    CUSTOM: 1,
    PRESET: 0
};

export const DEFAULT_COVER_SETTINGS = {
    foregroundTab: bgTypes.FROALA,
    foregroundDesktopImg: '',
    foregroundMobileImg: '',
    backgroundEnabled: false,
    backgroundTab: COVER_TABS.PRESET,
    backgroundType: bgTypes.SVG,
    backgroundDesktopImg: '',
    backgroundMobileImg: '',
    backgroundColor: ''
};
